import React from 'react';
import './style/Textarea.scss';

export default ({
    type = '',
    placeholder,
    disabled,
    autocomplete,
    maxLength,
    nameTextarea,
    idTextarea,
    autofocus,
    value,
    readonly,
    onTouchStart,
    onClick,
    onChange,
    ...rest
}) => {

    const handleChange = (event) => {
        if (onChange) {
            onChange(event, event.target.value);
        }
    }

    return (
        <textarea
            {...rest}
            disabled={disabled}
            placeholder={placeholder}
            autoComplete={autocomplete}
            autoFocus={autofocus}
            onChange={handleChange}
            onClick={onClick}
            onTouchStart={onTouchStart}
            maxLength={maxLength}
            id={idTextarea}
            name={nameTextarea}
            className={`textarea_${type}`}
            data-testid='Textarea'
            value={value}
            readOnly={readonly}
        />
    );
};